{
  "about": {
    "paragraph": "Siamo impegnati ad affrontare le sfide della legge AGEC e a informare i nostri clienti sull'origine e sulle qualità ambientali dei nostri prodotti.",
    "title": "Informazioni"
  },
  "lastUpdate": "Data dell'ultimo aggiornamento : ",
  "loading": {
    "dataPending": "sta attualmente raccogliendo queste informazioni",
    "pendingLocation": "Posizione in attesa"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Produzione di abbigliamento",
    "FOOTWEAR_FINISHING": "Finitura delle calzature",
    "FOOTWEAR_STITCHING": "Cucitura delle calzature",
    "FOOTWEAR_ASSEMBLING": "Assemblaggio delle calzature",
    "FABRIC_WEAVING_OR_KNITTING": "Tessitura o maglieria",
    "FABRIC_DYEING_PRINTING": "Tintura o stampa dei tessuti",
    "YARN_PROVIDER": "Fornitore di filati",
    "YARN_DYEING_PRINTING": "Tintura o stampa dei filati",
    "LEATHER_TANNING": "Concia della pelle",
    "LEATHER_DYEING_PRINTING": "Tintura o stampa della pelle",
    "ACCESSORY_PROVIDER": "Fornitore di accessori",
    "YARN_MATERIAL_PRODUCTION": "Produzione di materiale per filati",
    "FABRIC_SPINNING": "Filatura dei tessuti",
    "FABRIC_MATERIAL_PRODUCTION": "Produzione di materiale tessile",
    "LEATHER_MATERIAL_PRODUCTION": "Produzione di materiale in pelle",
    "LEATHER_FARM": "Fattoria di allevamento",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Fornitore di materie prime per accessori",
    "COATING": "Rivestimento"
  },
  "other": {
    "microplastics_bold": "rilascia microplastiche ",
    "paragraph1": "Questo prodotto contiene ",
    "paragraph1_100": "Questo prodotto contiene materiali riciclati al 100%.",
    "paragraph2_1": "Questo prodotto ",
    "paragraph2_2": "  nell'ambiente durante il lavaggio: ",
    "paragraph2_3": "per massa del prodotto è composto da fibre sintetiche.",
    "paragraph3": "Informazioni sulla potenziale presenza di sostanze pericolose nell'applicazione: ",
    "recycled_matertials_bold": "almeno {{percent}}% di materiali riciclati.",
    "recycled_matertials_bold_50": "più del 50% ",
    "title": "Altre qualità e caratteristiche ambientali"
  },
  "packaging": {
    "recyclable": "Riciclabile: L'imballaggio è riciclabile.",
    "recycled": "Materiali riciclati: L'imballaggio contiene almeno {{percent}}% di materiali riciclati.",
    "recycled_100": "Materiali riciclati: L'imballaggio contiene materiali riciclati al 100%.",
    "title": "Qualità e caratteristiche ambientali dell'imballaggio"
  },
  "title": "Scheda prodotto sulle qualità o caratteristiche ambientali",
  "traceability": {
    "paragraph": "Si riferisce all'origine del tuo prodotto nelle sue prime tre fasi di produzione, dalla sua creazione alla tessitura e alla tintura del suo materiale principale.",
    "title": "Tracciabilità del prodotto"
  },
  "ecoScore": {
    "title": "EcoScore",
    "b2b": "Costo ambientale : {{cost}} punti di impatto"
  }
}
